import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.typography.pxToRem(96),
  },
}));

const EditDeleteButtons = ({ row, selectedJobToDelete, onOpen }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.root}>
      <IconButton
        aria-label="edit"
        onClick={() => {
          onOpen(row);
        }}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        style={{ color: theme.palette.colorant.main }}
        aria-label="delete"
        onClick={() => {
          selectedJobToDelete(row);
        }}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  );
};

EditDeleteButtons.propTypes = {
  row: PropTypes.object.isRequired,
  selectedJobToDelete: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
};

export default EditDeleteButtons;
